var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailOpenLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.3831V11C3 11.5523 3.44772 12 4 12H12C12.5523 12 13 11.5523 13 11V6.3831C13 5.99445 12.576 5.75439 12.2428 5.95435L8.5145 8.1913C8.19781 8.38131 7.80219 8.38131 7.4855 8.1913L3.75725 5.95435C3.42399 5.75439 3 5.99445 3 6.3831Z",
    stroke: "#002A69",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6L8 3L13 6",
    stroke: "#002A69",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpenLine);
export default __webpack_public_path__ + "static/media/Mail_open_line.c3d73b529c0ceaf77d37772abf4bc532.svg";
export { ForwardRef as ReactComponent };